<div class="page-header">
    <div>
        <h4 class="section-title">Tools</h4>
        <p class="page-subtitle">
            The agent's AI employee (a team member with a role and no password) lets the agent look things up and act in the
            project's services, e.g. Leads. Read-only here: the customer connects the AI employee and switches services and
            tools on in the agents Dashboard; its role is changed in Team.
        </p>
    </div>
</div>

<div class="info-note" role="note" *ngIf="planOff">
    <i class="fa-solid fa-circle-info"></i>
    <span>The project plan does not include tools: the agent answers without them. Allow "Tools" on the Project plans page.</span>
</div>
<div class="info-note" role="note" *ngIf="modelWithoutTools">
    <i class="fa-solid fa-circle-info"></i>
    <span>The agent's model ({{ model?.displayName }}) cannot use tools, so the agent answers without them. Choose a model with "Supports tools" to use them.</span>
</div>

<!-- AI EMPLOYEE -->
<div class="tools-box" id="ag-tools-account">
    <h5 class="box-title"><i class="fa-solid fa-user-gear"></i> AI employee</h5>
    <div *ngIf="accountLoading" class="muted">Loading...</div>
    <div *ngIf="accountError" class="error-text" role="alert">{{ accountError }}</div>
    <ng-container *ngIf="!accountLoading && !accountError">
        <p *ngIf="!account?.connected" class="muted" id="ag-tools-account-none">
            <span class="badge off">Not connected</span>
            No AI employee is connected, so the agent works without tools.
        </p>
        <dl *ngIf="account?.connected" class="tools-facts">
            <dt>Name</dt>
            <dd dir="auto">{{ account?.name || '-' }}</dd>
            <dt>Status</dt>
            <dd><span class="badge" [ngClass]="status.css" id="ag-tools-account-status">{{ status.label }}</span></dd>
            <dt>Key prefix</dt>
            <dd><span class="mono">{{ account?.keyPrefix || '-' }}</span></dd>
            <dt>User ID</dt>
            <dd><span class="mono">{{ account?.authUserId || '-' }}</span></dd>
            <dt>Connected</dt>
            <dd>{{ account?.connectedAt ? (account?.connectedAt | date: 'medium') : '-' }}</dd>
        </dl>
    </ng-container>
</div>

<!-- TOOL CONNECTIONS -->
<div class="tools-box" id="ag-tools-connections">
    <h5 class="box-title"><i class="fa-solid fa-plug"></i> Tool connections</h5>
    <p class="muted tools-count" *ngIf="connections.length || planMax !== null">
        {{ connections.length }} service{{ connections.length === 1 ? '' : 's' }}, {{ enabledCount }} switched on<span *ngIf="planMax !== null"> · plan allows {{ planMax }} per agent</span>
        · <span [class.ok-text]="toolsInUse">{{ toolsInUse ? 'the agent uses tools' : 'the agent does not use tools now' }}</span>
    </p>
    <div *ngIf="toolsLoading && connections.length === 0" class="muted">Loading...</div>
    <div *ngIf="toolsError" class="error-text" role="alert">{{ toolsError }}</div>
    <div *ngIf="!toolsLoading && !toolsError && connections.length === 0" class="no-data">
        <i class="fa-solid fa-plug"></i> No MCP services are configured in the agent service
    </div>

    <div class="tool-service" *ngFor="let c of connections" [attr.id]="'ag-tools-service-' + c.service">
        <div class="tool-service-head">
            <strong>{{ c.title || c.service }}</strong>
            <span class="mono">{{ c.service }}</span>
            <span class="badge" [ngClass]="c.available ? 'ok' : 'off'">{{ c.available ? 'Available' : 'Not available' }}</span>
            <span class="badge" [ngClass]="c.enabled ? 'ok' : 'off'">{{ c.enabled ? 'On' : 'Off' }}</span>
            <span class="badge" [ngClass]="c.confirmWrites ? 'draft' : 'warn'">
                {{ c.confirmWrites ? 'Asks the visitor before every change' : 'Changes without asking' }}
            </span>
        </div>
        <p class="muted" *ngIf="!c.available">{{ unavailableReason(c, account) }}</p>
        <p class="muted" *ngIf="c.available">
            {{ allowedToolCount(c) }} of {{ c.tools.length }} tool{{ c.tools.length === 1 ? '' : 's' }} allowed{{ c.allowedTools === null || c.allowedTools === undefined ? ' (every tool the role allows)' : '' }}
        </p>
        <div class="table-wrapper table-mobile-card" *ngIf="c.tools.length">
            <table class="table">
                <thead>
                    <tr>
                        <th>Tool</th>
                        <th>Description</th>
                        <th>Kind</th>
                        <th class="status-col">Allowed</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let t of c.tools">
                        <td data-label="Tool"><strong dir="auto">{{ t.title || t.name }}</strong> <span class="mono">{{ t.name }}</span></td>
                        <td data-label="Description"><span class="tool-desc" dir="auto" [title]="t.description || ''">{{ t.description || '-' }}</span></td>
                        <td data-label="Kind">
                            <span class="badge" [ngClass]="t.readOnly ? 'ok' : t.destructive ? 'warn' : 'draft'">{{ toolKindLabel(t) }}</span>
                        </td>
                        <td data-label="Allowed" class="status-col">
                            <span [ngClass]="t.allowed ? 'status-active' : 'status-disabled'">{{ t.allowed ? 'Yes' : 'No' }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
